export const reports = {
  cancel: "Cancel",
  download: "Download",
  selectPayouts: "Select payout periods",
};
